import { styled } from "styled-components";
import { Form } from "@template/components/Form/styles.ts";
import {
  Arch,
  ArchStandaloneSectionWrapper,
} from "@template/blocks/ArchStandaloneSection/component/styles.ts";

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 64px 24px;
  position: relative;

  > div {
    max-width: 1024px;
  }

  ${Form} {
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: flex-end;
    ${({ theme }) => theme.breakpoints.sm.query} {
      flex-direction: column;
      align-items: center;
      button {
        width: 100% !important;
        margin-left: revert;
      }
    }
  }

  ${ArchStandaloneSectionWrapper} {
    position: absolute;
    left: 0;
    width: 100vw;
    max-width: revert;
    height: 100%;

    ${Arch} {
      top: 100px;
      width: 200%;
    }
  }
`;
